import type { GridColDef } from './types';

/** Fit unresized flex columns around fixed widths, respecting each column's bounds. */
export function fitColumnWidths(
  columns: readonly GridColDef[],
  availableWidth: number,
  resized: Readonly<Record<string, number>>,
): Record<string, number> {
  const widths: Record<string, number> = {};
  const flexible = columns.filter((column) => column.flex && resized[column.field] === undefined);
  for (const column of columns) {
    widths[column.field] = Math.min(
      column.maxWidth ?? 2000,
      Math.max(
        column.minWidth ?? 50,
        resized[column.field] ?? column.width ?? column.minWidth ?? 100,
      ),
    );
  }
  let remaining = Math.max(
    0,
    Math.floor(availableWidth) - Object.values(widths).reduce((a, b) => a + b, 0),
  );
  let active = flexible;
  while (remaining > 0.01 && active.length) {
    const totalFlex = active.reduce((sum, column) => sum + column.flex!, 0);
    let used = 0;
    for (const column of active) {
      const extra = Math.min(
        (remaining * column.flex!) / totalFlex,
        (column.maxWidth ?? 2000) - widths[column.field],
      );
      widths[column.field] += extra;
      used += extra;
    }
    remaining -= used;
    active = active.filter((column) => widths[column.field] < (column.maxWidth ?? 2000));
  }
  return widths;
}
